<template>
  <div class=" AboutService my-5">
    <div class="row" style="    display: flex;
    justify-content: space-between;">
      <div class="col-md-6 col-lg-6 col-sm-6 FadeRight" id="card1" data-aos="fade-right"
           data-aos-offset="200"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false" style="padding:40px">
        <div class="row">
          <div class="moto-widget-text-content moto-widget-text-editable">
            <p class="moto-text_system_13 animate1" style="text-align: center;">
              <span class="display-9 my-3 font-weight-bold moto-color1_3 animate1">24 HOUR SERVICE</span>
            </p>
            <div class="dez-separator bg-primary"></div>
            <!-- <h3 class="moto-text_system_12" style="text-align: center;">
              <span class="moto-color5_5 display-8 my-3 font-weight-bold">DOOR TO DOOR<br>SERVICE</span>
            </h3> -->
            <!-- <p class="moto-text_normal" style="text-align: center;">&nbsp;</p> -->
            <p class="moto-text_normal my-3" style="text-align: center;">
              <span class="moto-color5_5">Our reliable taxi sedan and van services go far beyond the norm. We not only get you where you need to be, but we transport you with a level of care that can only be achieved through years of experience serving the area.



Our taxi operators are local experts who know the best routes to get you to your destination on time. And we rely on GPS technology to further ensure quick, accurate service.</span>
          </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 img-service"  data-aos="fade-left"
           data-aos-offset="200"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false" >
        <p class="moto-text_normal" style="text-align: center">&nbsp;</p>
        <img src="@/assets/abtserv.jpeg" width="90%" class="img-border" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutService",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.animate1,.animate2,.animate3{
  position: relative;
  top: 0;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
#card1:hover .animate1{    top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  color: #EFBB20
  }
.img-service {
  /* width: 50%; */
  /* margin-top: 82px; */
  /* -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto; */
  border-radius: 10px;
  padding: 20px;
}
.moto-text_normal {
  font-weight: 300;
  font-style: normal;
  font-family: "Raleway", sans-serif;
  color: #333333;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0px;
}
.img-border {
  border-radius: 10px;
}
/* @media screen and (max-width: 768px) {
  .img-border {
    width: 90%;
  }
} */
.moto-widget-text-content {
  padding: 0 1px;
}
.moto-text_system_13 {
  font-weight: 700;
  font-style: normal;
  font-family: "Raleway", sans-serif;
  color: #ffffff;
  font-size: 66px;
  line-height: 1;
  letter-spacing: -2px;
}
.moto-color1_3 {
  color: #ffffff;
}
.moto-text_system_12 {
  font-weight: 500;
  font-style: normal;
  font-family: "Raleway", sans-serif;
  color: #333333;
  font-size: 30px;
  line-height: 1.4;
  letter-spacing: 0px;
}
.moto-color5_5 {
  color: #ffffff;
}
.moto-text_normal {
  font-weight: 300;
  font-style: normal;
  font-family: "Raleway", sans-serif;
  color: #333333;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0px;
}
.dez-separator {
  display: inline-block;
  height: 3px;
  width: 80px;
  margin-bottom: 10px;
  position: relative;
  /*-moz-transition: all 0.5s;*/
  /*-webkit-transition: all 0.5s;*/
  /*transition: all 0.5s;*/
}
.FadeRight:hover .dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 150px;
  background-color: #ffde20 !important;
}
.FadeDown:hover .dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 150px;
  background-color: #ffde20 !important;
}
.FadeLeft:hover .dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 150px;
  background-color: #ffde20 !important;
}
.FadeLeft:hover .dez-separator {
  background-color: #ffde20 !important;
}
.dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.bg-primary {
  background-color: #ffffff !important;
}
</style>
